import styled from 'styled-components';

export const MidBannerContainer = styled.div`
    width: 100%;
    height: auto;
    border: solid rgba(255,255,255,0.2) 0.5px;

`;